// import React from 'react';
// import { useQuery } from '@apollo/client';
// import { LISTING_DATA } from 'pages/Dashboard/components/DashboardGraphQL';
// import { defaultFiltersForDates } from 'pages/Dashboard/components/constant';
// import Loader from 'components/common/Loader';
// import LineChart from '../../../LineChart';

// const ListingChart = ({ selectedOption }) => {
//   const { data, loading, error } = useQuery(LISTING_DATA, {
//     variables: defaultFiltersForDates(selectedOption),
//     fetchPolicy: 'network-only',
//   });

//   if (error) return `There is an error on this page : ${error.message} `;
//   if (loading)
//     return (
//       <div className="linechart-loader">
//         <Loader />
//       </div>
//     );

//   const combinedKeysSet = new Set();
//   let firstLineData = [];
//   let secondLineData = [];

//   if (data?.listingCountData?.offers.length) {
//     firstLineData = data.listingCountData.offers.map((val) => {
//       combinedKeysSet.add(val[defaultFiltersForDates(selectedOption).groupOn]);
//       return val.count;
//     });
//   }
//   if (data?.listingCountData?.demands.length) {
//     secondLineData = data.listingCountData.demands.map((val) => {
//       combinedKeysSet.add(val[defaultFiltersForDates(selectedOption).groupOn]);
//       return val.count;
//     });
//   }
//   const combinedKeys = Array.from(combinedKeysSet);

//   return (
//     <>
//       {' '}
//       <LineChart
//         combinedKeys={combinedKeys}
//         firstLineData={firstLineData}
//         secondLineData={secondLineData}
//         firstHeading="New Offers"
//         secondHeading="New Demands"
//       />
//     </>
//   );
// };

// export default ListingChart;

// import React from 'react';
// import { useQuery } from '@apollo/client';
// import { LISTING_DATA } from 'pages/Dashboard/components/DashboardGraphQL';
// import { defaultFiltersForDates, formatXAxisLabels } from 'pages/Dashboard/components/constant';
// import Loader from 'components/common/Loader';
// import LineChart from '../../../LineChart';

// const ListingChart = ({ selectedOption }) => {
//   const { data, loading, error } = useQuery(LISTING_DATA, {
//     variables: defaultFiltersForDates(selectedOption),
//     fetchPolicy: 'network-only',
//   });

//   if (error) return `There is an error on this page : ${error.message} `;
//   if (loading)
//     return (
//       <div className="linechart-loader">
//         <Loader />
//       </div>
//     );

//   let firstLineData = [];
//   let secondLineData = [];

//   // Get X-axis labels based on selected option
//   const xAxisLabels = formatXAxisLabels(selectedOption);

//   if (data?.listingCountData?.offers?.length) {
//     firstLineData = data.listingCountData.offers.map((val) => val.count);
//   }
//   if (data?.listingCountData?.demands?.length) {
//     secondLineData = data.listingCountData.demands.map((val) => val.count);
//   }

//   // Pad arrays to match X-axis labels length
//   while (firstLineData.length < xAxisLabels.length) {
//     firstLineData.push(0);
//   }
//   while (secondLineData.length < xAxisLabels.length) {
//     secondLineData.push(0);
//   }

//   return (
//     <LineChart
//       combinedKeys={xAxisLabels}
//       firstLineData={firstLineData}
//       secondLineData={secondLineData}
//       firstHeading="New Offers"
//       secondHeading="New Demands"
//     />
//   );
// };

// export default ListingChart;

import React from 'react';
import moment from 'moment';
import { useQuery } from '@apollo/client';
import { LISTING_DATA } from 'pages/Dashboard/components/DashboardGraphQL';
import {
  defaultFiltersForDates,
  formatXAxisLabels,
} from 'pages/Dashboard/components/constant';
import PermissionNotice from 'pages/Dashboard/components/PermissionNotice';
import Loader from 'components/common/Loader';
import LineChart from '../../../LineChart';

const ListingChart = ({ selectedOption, canView = true }) => {
  const { data, loading, error } = useQuery(LISTING_DATA, {
    variables: defaultFiltersForDates(selectedOption),
    fetchPolicy: 'network-only',
    skip: !canView,
  });

  if (!canView) {
    return (
      <PermissionNotice message="You do not have permission to view Listing chart." />
    );
  }

  if (error) return `There is an error on this page : ${error.message}`;
  if (loading)
    return (
      <div className="linechart-loader">
        <Loader />
      </div>
    );

  let firstLineData = [];
  let secondLineData = [];

  // X-axis labels generate करें
  let xAxisLabels = formatXAxisLabels(selectedOption);

  // API response ko process करें
  if (data?.listingCountData) {
    const { offers, demands } = data.listingCountData;

    if (selectedOption === 'this_year') {
      // Year ke liye month-wise mapping (no Sunday filter needed for months)
      const offersMap = {};
      const demandsMap = {};

      offers?.forEach((item) => {
        const month = moment(item.day || item.month).format('MMM');
        offersMap[month] =
          (offersMap[month] || 0) + parseInt(item.count || 0, 10);
      });

      demands?.forEach((item) => {
        const month = moment(item.day || item.month).format('MMM');
        demandsMap[month] =
          (demandsMap[month] || 0) + parseInt(item.count || 0, 10);
      });

      // X-axis labels ke according data fill करें
      firstLineData = xAxisLabels.map((label) => offersMap[label] || 0);
      secondLineData = xAxisLabels.map((label) => demandsMap[label] || 0);
    } else {
      // Day-wise mapping for last_7_days and last_30_days
      const offersMap = {};
      const demandsMap = {};

      offers?.forEach((item) => {
        const date = moment(item.day).format('D MMM');
        offersMap[date] = parseInt(item.count, 10) || 0;
      });

      demands?.forEach((item) => {
        const date = moment(item.day).format('D MMM');
        demandsMap[date] = parseInt(item.count, 10) || 0;
      });

      xAxisLabels = xAxisLabels.filter((label) => {
        const date = moment(label, 'D MMM');
        return date.day() !== 0; // 0 = Sunday
      });

      // X-axis labels ke according data fill करें
      firstLineData = xAxisLabels.map((label) => offersMap[label] || 0);
      secondLineData = xAxisLabels.map((label) => demandsMap[label] || 0);
    }
  }

  return (
    <LineChart
      combinedKeys={xAxisLabels}
      firstLineData={firstLineData}
      secondLineData={secondLineData}
      firstHeading="Total Offers"
      secondHeading="Total Demands"
    />
  );
};

export default ListingChart;
